import { getCookie } from "./utils";

export const routes = {
  dashboard: "/dashboard",
  deviceManagement: "/device-management",
  users: "/users",
  alertsApproval: "/alerts/alert-approval",
  quickAlerts: "/alerts/quick-alerts",
  alerts: "/alerts",
  deviceSetup: "/device-set-up",
  integrations: "/integrations",
  dasConfigure: "/integrations/das",
  singlewireConfigure: "/integrations/singlewire",
  everbridgeConfigure: "/integrations/everbridge",
  alertusConfigure: "/integrations/alertus",
  capConfigure: "/integrations/cap",
  superAdmin: "/super-admin",
  organizationUsers: "/super-admin/users",
  superAdminDeviceManagement: "/super-admin/device-management",
  ManageUpdates: "/manage-updates",
  DeviceLogs: "/device-logs",
  analytics: "/analytics",
  userGuide: "/user-guide",
  manageTemplates: "/manage-templates",
};
export const Status = {
  IDLE: "idle",
  SUCCESS: "success",
  PENDING: "pending",
  FAILED: "failed",
};

export const TABLE_RENDERING_MODES = {
  CLIENT_SIDE: "client",
  SERVER_SIDE: "server",
};
export const SEVERITY_OPTIONS = ["High", "Medium", "Low"];
export const SOURCE_OPTIONS = [
  "MAN",
  "DAS",
  "INFORMACAST",
  "EVERBRIDGE",
  "PUBLIC API",
  "PAPI",
  "ALERTUS",
  "CAP",
];

export const STATUS_OPTIONS = [
  "Live",
  "Partially Live",
  "Past",
  "Failed",
  "Scheduled",
];

export const FLASHCAST_USER_GUIDE_URL =
  "https://cdn.shopify.com/s/files/1/0026/7132/files/Flashcast_User_ManualV1.2.9.pdf";

export const LICENSE_TYPES = {
  MOBILE: "mobile",
};

export const LICENSE_NAME = {
  MOBILE: "Mobile License",
};

export const ACTION = {
  ENABLE: "Enable",
  DISABLE: "Disable",
  MANAGE: "Manage",
};
export const statusCode = {
  ok: 200,
  badRequest: 400,
  internalServerError: 500,
  unauthorised: 401,
};

export enum RowType {
  DEVICE = "device",
  GROUP = "group",
  USER = "user",
}

export enum SuccessMessage {
  DELETE = "Successfully deleted",
  UPDATE = "Updated Successfully",
}
export enum ROLE {
  SUPERADMIN = "SUPERADMIN",
  ADMIN = "ADMIN",
  OPERATOR = "OPERATOR",
  VIEWER = "VIEWER",
}

export const permissions = {
  "user.edit": [ROLE.ADMIN, ROLE.OPERATOR],
  "user.delete": [ROLE.ADMIN],
  "user.read": Object.values(ROLE),
  "user.superadmin": [ROLE.SUPERADMIN],
};

export interface UserRole {
  id: string;
  displayName: ROLE;
}

export type PermissionName = keyof typeof permissions;

export const DefaultTopLevelGroup = {
  get ID() {
    return getCookie("groupId");
  },
};

export const MIMO_GROUP_ID: string = "1353899013";

export const QUICK_ALERT_PAGE_LIMIT: number = 20;

export enum DataAvailabilityMessages {
  NO_DEVICE_AVAILABLE = "No devices available",
  NO_ALERT_AVAILABLE = "No alerts available",
  ALERT_DATA_LOADING = "Alerts Data Loading",
  NO_USER_AVAILABLE = "No users available",
  USER_DATA_LOADING = "Users Data Loading",
  NO_TOKEN_AVAILABLE = "No Token available",
  TOKEN_DATA_LOADING = "Token Data Loading",
  NO_DEVICE_ADDED = "",
  NO_FIRMWARE_AVAILABLE = "No firmware available",
  NO_IOT_AGENT_AVAILABLE = "No Iot Agent available",
}

export enum Selected {
  YES = "Yes",
  NO = "No",
}

export enum SignInProvider {
  EMAIL = "email",
  MICROSOFT = "microsoft",
  GOOGLE = "google",
}

export const CLIENT_TYPE = {
  WEB: "web",
  MOBILE: "mobile",
};

export const FILE_TYPE = {
  FIRMWARE: "firmware",
  IOT_AGENT: "iot_agent",
};

export const ERROR_MESSAGES = {
  DEVICE_ID_EMPTY: "Device ID cannot be empty",
  FAILED_TO_COPY: "Failed to copy text: ",
};

export const WEBHOOK_PLACEHOLDER = {
  PLACEHOLDER: "Add Token to get the Webhook URL.",
};

export const WEBHOOK_UPDATE_MESSAGE =
  "Your webhook URL has been updated for improved security. Please copy the new URL below and update it in your integration portal. This notification will remain until we receive an alert from the updated URL.";

export const US_DAYLIGHT_TIMEZONES = [
  { value: "MST", label: "MST" },
  { value: "MDT", label: "MDT" },
  { value: "PDT", label: "PDT" },
  { value: "CDT", label: "CDT" },
  { value: "EDT", label: "EDT" },
  { value: "AKDT", label: "AKDT" },
  { value: "HST", label: "HST" },
  { value: "ADT", label: "ADT" },
];

export const ALERT_ICONS = [
  { value: "Select Template", label: "Select Template" },
  { value: "pic:0", label: "PIC 0" },
  { value: "pic:1", label: "PIC 1" },
  { value: "pic:2", label: "PIC 2" },
  { value: "pic:3", label: "PIC 3" },
  { value: "pic:4", label: "PIC 4" },
  { value: "pic:5", label: "PIC 5" },
  { value: "pic:6", label: "PIC 6" },
  { value: "pic:7", label: "PIC 7" },
];

export const ALL_TEXT_ALERT_COLOR = [
  { value: 20, label: "Blue" },
  { value: 21, label: "Red" },
  { value: 22, label: "Yellow" },
  { value: 23, label: "Green" },
];

export const MIMO_LOGOS = [
  { value: "Select Logo", label: "Select Logo" },
  { value: "pic:0", label: "PIC 0" },
  { value: "pic:1", label: "PIC 1" },
];

export const TEMPLATE_15 = [
  { value: "Select Template", label: "Select Template" },
  { value: "Stay in Place Emergency:", label: "Stay in Place Emergency" },
  { value: "All Clear Notice:", label: "All Clear Notice" },
];

export const US_STANDARD_TIMEZONES = [
  { value: "MST", label: "MST" },
  { value: "PST", label: "PST" },
  { value: "CST", label: "CST" },
  { value: "EST", label: "EST" },
  { value: "AKST", label: "AKST" },
  { value: "HST", label: "HST" },
  { value: "AST", label: "AST" },
];

export const US_TIMEZONES_ABBREVIATIONS = {
  PDT: "America/Los_Angeles",
  MST: "America/Denver",
  MDT: "America/Denver",
  CDT: "America/Chicago",
  EDT: "America/New_York",
  AKDT: "America/Anchorage",
  HST: "America/Adak",
  AST: "America/Puerto_Rico",
  PST: "America/Los_Angeles",
  CST: "America/Chicago",
  EST: "America/New_York",
  AKST: "America/Anchorage",
};

export const US_DEFAULT_TIMEZONE = "America/New_York";

export const RESET_PASSWORD_MESSAGE = {
  SUCCESS: "Password reset link sent successfully",
  FAILED: "Please enter a valid/registered email address.",
};

export const ALERT_TEMPLATE_LINKS = {
  TEMPLATE_1:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-1.png",
  TEMPLATE_2:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-2.png",
  TEMPLATE_3:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-3.png",
  TEMPLATE_4:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-4.png",
  TEMPLATE_5:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-5.png",
  TEMPLATE_6:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-6.png",
  TEMPLATE_7:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-7.png",
  TEMPLATE_8:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-8.png",
  TEMPLATE_9:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-9.png",
  TEMPLATE_10:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-10.png",
  TEMPLATE_11:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-11.png",
  TEMPLATE_12:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-12.png",
  TEMPLATE_13:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-13.png",
  TEMPLATE_14:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-14.png",
  TEMPLATE_15:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-15.png",
  TEMPLATE_16:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-16.png",
  TEMPLATE_17:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-17.png",
  TEMPLATE_18:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-18.png",
  TEMPLATE_19:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-19.png",
  TEMPLATE_20:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-alert-templates/template-20.png",
};

export const PUBLIC_TEMPLATE_IDS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23,
];

export const THIRD_PARTY_INTEGRATION_LINKS = {
  EVERBRIDGE:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-third-party-logos/everbridge.png",
  ALERTUS:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-third-party-logos/alertus_logo.png",
  INFORMACAST:
    "https://flashcastlogsandimages.blob.core.windows.net/flashcast-third-party-logos/singlewire.png",
  DAS: "https://flashcastlogsandimages.blob.core.windows.net/flashcast-third-party-logos/digital-alert-system.png",
  MIMO: "https://flashcastlogsandimages.blob.core.windows.net/flashcast-third-party-logos/mimo-monitors-logo.png",
  CAP: "https://flashcastlogsandimages.blob.core.windows.net/flashcast-third-party-logos/mimo-monitors-logo.png",
};

export const DEFAULT_ERROR_MESSAGE =
  "An error occurred while processing your request.";
export const PUBLIC_API_DOCUMENTATION_URL = "/public-api-guide";
export const ALERTUS_USER_GUIDE_URL =
  "https://intimetecvisionsoft.sharepoint.com/:w:/r/sites/MimoMonitors/Shared%20Documents/Fuji%20Deployments/AlertUs%20Integration%20User%20Guide%20.docx?d=w5e486374ea1a43b1a4beb6eb15ef2fa8&csf=1&web=1&e=R5Juni";
export const FIREBASE_ERROR_MESSAGE: Record<string, string> = {
  // Authentication errors
  "auth/invalid-email": "Invalid email address format.",
  "auth/user-disabled": "This account has been disabled.",
  "auth/user-not-found": "No user found with this email.",
  "auth/wrong-password": "Password is incorrect.",
  "auth/invalid-credential": "Invalid login credentials.",
  "auth/invalid-password": "Password is invalid.",
  "auth/email-already-in-use": "This email is already registered.",
  "auth/weak-password":
    "New password is too weak. It should be at least 6 characters.",
  "auth/operation-not-allowed": "This operation is currently not allowed.",
  "auth/account-exists-with-different-credential":
    "An account already exists with the same email address but different sign-in credentials.",
  "auth/credential-already-in-use":
    "This credential is already associated with another account.",
  "auth/requires-recent-login":
    "This operation is sensitive and requires recent authentication. Please log in again.",
  "auth/user-mismatch":
    "The credentials do not correspond to the currently logged-in user.",
  "auth/missing-password": "Password is a required field.",
  "auth/user-cancelled":
    "Sign-in cancelled. Please grant permissions to continue.",

  // Throttling & network
  "auth/too-many-requests": "Too many failed attempts. Please try again later.",
  "auth/network-request-failed":
    "Network error. Please check your connection and try again.",
  "auth/popup-closed-by-user":
    "The sign-in popup was closed before completing the sign in.",
  "auth/popup-blocked": "The sign-in popup was blocked by the browser.",
  "auth/cancelled-popup-request":
    "Only one popup request is allowed at one time.",
  "auth/timeout": "Request timed out. Please try again.",

  // Token/session errors
  "auth/id-token-expired": "Your session has expired. Please sign in again.",
  "auth/invalid-id-token": "Invalid session token. Please sign in again.",
  "auth/no-auth-event": "No authentication event found.",
  "auth/internal-error": "Internal error occurred. Please try again later.",
};

export const DEFAULT_REPORT_DOWNLOAD_MESSAGE = {
  SUCCESS: "Report downloaded successfully",
  FAILED: "Failed to download report. Please try again.",
};
